import React from 'react';
import './OfficeContentRow.scss';
import { getModuleBackgroundColor } from '../../../../util/getModuleBackgroundColor';

/**
 * Renders an office content row of a specific orientation
 * @param {('right'|'left'|'center')} orientation
 * @param {object} imageOne
 * @param {object} imageTwo
 * @param {string} message
 */
const OfficeContentRow = ({ orientation, imageOne, imageTwo, message }) => (
  <div className="c-office-content-row">
    {orientation === 'right' && (
      <>
        <div className="c-office-content-row__image-large content-right">
          <img src={imageOne.url} alt={imageOne.alt} />
        </div>
        <div className="c-office-content-row__images-container content-right">
          <div
            className={`c-office-content-row__message h3-roobert ${getModuleBackgroundColor(
              message.backgroundColor,
            )}`}
          >
            <h3>{message.content}</h3>
          </div>
          <div className="c-office-content-row__image-small">
            <img src={imageTwo.url} alt={imageTwo.alt} />
          </div>
        </div>
      </>
    )}
    {orientation === 'left' && (
      <>
        <div className="c-office-content-row__images-container content-left">
          <div
            className={`c-office-content-row__message h3-roobert ${getModuleBackgroundColor(
              message.backgroundColor,
            )}`}
          >
            <h3>{message.content}</h3>
          </div>
          <div className="c-office-content-row__image-small">
            <img src={imageTwo.url} alt={imageTwo.alt} />
          </div>
        </div>
        <div className="c-office-content-row__image-large content-left">
          <img src={imageOne.url} alt={imageOne.alt} />
        </div>
      </>
    )}
    {orientation === 'center' && (
      <>
        <div className="c-office-content-row__image-large content-center">
          <img src={imageOne.url} alt={imageOne.alt} />
        </div>
        <div className="c-office-content-row__images-container content-center">
          <div
            className={`c-office-content-row__message h3-roobert ${getModuleBackgroundColor(
              message.backgroundColor,
            )}`}
          >
            <h3>{message.content}</h3>
          </div>
          <div className="c-office-content-row__image-small">
            <img src={imageTwo.url} alt={imageTwo.alt} />
          </div>
        </div>
      </>
    )}
  </div>
);

export default OfficeContentRow;
